/** 系统设置路由 */
export default{
    name: 'system',
    path: 'system',
    meta: { title: '系统设置' },
    component: ()=>import('@/pages/index.vue'),
    children: [
        {
            name: 'system-industry',
            path: 'industry',
            meta: { title: '行业管理' },
            component: ()=>import('@/pages/system/industry.vue')
        },
        {
            name: 'system-tag',
            path: 'tag',
            meta: { title: '标签管理' },
            component: ()=>import('@/pages/system/tag.vue')
        },
        {
            name: 'system-customertype',
            path: 'customertype',
            meta: { title: '客户类型管理' },
            component: ()=>import('@/pages/system/customertype.vue')
        },
        {
            name: 'system-transactiontype',
            path: 'transactiontype',
            meta: { title: '成交方式管理' },
            component: ()=>import('@/pages/system/transactiontype.vue')
        },
        {
            name: 'system-dock',
            path: 'dock',
            meta: { title: '对接方式管理' },
            component: ()=>import('@/pages/system/dock.vue')
        },
        {
            name: 'system-config',
            path: 'config',
            meta: { title: '企微配置' },
            component: ()=>import('@/pages/system/config.vue')
        },
        {
            name: 'system-orderproduct',
            path: 'orderproduct',
            meta: { title: '订单产品' },
            component: ()=>import('@/pages/system/orderproduct.vue')
        },
        {
            name: 'system-customersource',
            path: 'customersource',
            meta: { title: '客户来源' },
            component: ()=>import('@/pages/system/customersource.vue')
        }
    ]
}
